import { render, staticRenderFns } from "./GastroCartellaInfermieristicaEdit.vue?vue&type=template&id=7c8e1e44"
import script from "./GastroCartellaInfermieristicaEdit.vue?vue&type=script&lang=js"
export * from "./GastroCartellaInfermieristicaEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports